import { useContext } from 'react'

import { RoomContext, type RoomContextState } from 'modules/meetings/lib/context/RoomContext'

export const useRoom = (): RoomContextState => {
  const context = useContext(RoomContext)

  if (context === undefined) {
    throw new Error('useRoom must be used within a RoomProvider')
  }

  return context
}
